export const trackEvent = (eventName: string, eventData?: unknown) => {
  const hostname =
    window.location.hostname === 'localhost'
      ? 'mydom.farmtrx-development.com'
      : window.location.hostname
  const data: { payload: Record<string, unknown>; type: string } = {
    payload: {
      hostname: hostname,
      language: navigator.language,
      referrer: '',
      screen: `${window.screen.width}x${window.screen.height}`,
      title: document.title,
      url: window.location.pathname,
      website: USAGE_TRACKING_ID,
      name: eventName,
    },
    type: 'event',
  }
  if (eventData) {
    data.payload.data = eventData
  }
  fetch('https://cloud.umami.is/api/send', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).catch((error) => {
    console.log('Error sending tracking event:', error)
  })
}
